import { render, staticRenderFns } from "./salaryApplicationDetail.vue?vue&type=template&id=3ca4305a&scoped=true&"
import script from "./salaryApplicationDetail.vue?vue&type=script&lang=js&"
export * from "./salaryApplicationDetail.vue?vue&type=script&lang=js&"
import style0 from "./salaryApplicationDetail.vue?vue&type=style&index=0&id=3ca4305a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca4305a",
  null
  
)

export default component.exports